import { AI_FEATURES } from "./AI_FEATURES";
import { MAC_IN_REVIEW } from "./MAC_IN_REVIEW";
import { WEB_CALENDAR_QUOTA } from "./WEB_CALENDAR_QUOTA";
import { WEB_LOCALIZED_PRICING_FEB23 } from "./WEB_LOCALIZED_PRICING_FEB23";
import { WEB_OB_AI_MAR_24 } from "./WEB_OB_AI_MAR_24";
import { WEB_PREMIUM_TRIAL } from "./WEB_PREMIUM_TRIAL";

export const AbServiceExperiments = {
  AI_FEATURES,
  MAC_IN_REVIEW,
  WEB_LOCALIZED_PRICING_FEB23,
  WEB_OB_AI_MAR_24,
  WEB_PREMIUM_TRIAL,
  WEB_CALENDAR_QUOTA,
};
